import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const Hyperlipidemia = {
  label: "高血脂",
  key: "Hyperlipidemia",
  path: "HealthCenterHealthCheckup/Hyperlipidemia",
  api: "TCS_V_HCCS05",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.Hyperlipidemia {...options} />
  ),
  filter: {
    key: "種類",
    value: "高血脂",
  },
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
  exportColumns: [
    {
      key: "是否異常",
      label: "是否異常",
    },
  ],
};
